'use strict';

import comparisonMap from './comparisonMap';
import comparisonSlider from './comparisonSlider';

export default function comparisonView() {

    comparisonMap();

    comparisonSlider();
}
